import(/* webpackMode: "eager" */ "/var/www/Name-Arcane/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/var/www/Name-Arcane/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Manrope\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-sans\"}],\"variableName\":\"manrope\"}");
;
import(/* webpackMode: "eager" */ "/var/www/Name-Arcane/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Cinzel\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-fantasy\",\"weight\":[\"500\",\"700\",\"800\"]}],\"variableName\":\"cinzel\"}");
;
import(/* webpackMode: "eager" */ "/var/www/Name-Arcane/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/Name-Arcane/src/components/layout/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/Name-Arcane/src/components/layout/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/var/www/Name-Arcane/src/context/Providers.tsx");
